import { CarouselApi } from '@/components/ui/carousel';
import { useEffect, useState } from 'react';

export const useCarouselData = () => {
    const [api, setApi] = useState<CarouselApi>();
    const [current, setCurrent] = useState(0);
    const [count, setCount] = useState(0);
    const [canScrollPrev, setCanScrollPrev] = useState(false);
    const [canScrollNext, setCanScrollNext] = useState(false);

    useEffect(() => {
        if (!api) {
            return;
        }

        const sync = () => {
            setCurrent(api.selectedScrollSnap());
            setCount(api.scrollSnapList().length);
            setCanScrollPrev(api.canScrollPrev());
            setCanScrollNext(api.canScrollNext());
        };

        sync();

        api.on('select', sync);
        api.on('scroll', sync);
        api.on('reInit', sync);
        api.on('resize', sync);

        return () => {
            api.off('select', sync);
            api.off('scroll', sync);
            api.off('reInit', sync);
            api.off('resize', sync);
        };
    }, [api]);

    return {
        api,
        setApi,
        current,
        count,
        canScrollPrev,
        canScrollNext,
    };
};
